export const useGuestStore = defineStore('guest', () => {
  const guestPrompt = ref(false)
  const authState = useAuthState()

  const isGuest = computed(() => {
    return authState.status.value !== 'authenticated'
  })

  return {
    isGuest,
    guestPrompt
  }
})